import { useUIContext } from 'lib/context/UIContext/UIContext';
import { formatDate } from 'lib/helpers/dateUtils';
import { mString } from 'lib/helpers/utility';

import Typography from 'components/shared/Typography/Typography';

import TransactionStatus from './TransactionStatus';

const TransactionItem = ({ value, label }) => {
  return (
    <div className="flex items-center gap-1.5">
      <Typography
        variant="p"
        size="xs"
        weight="medium"
        color="neutral-700"
        className="whitespace-nowrap">
        {label}
      </Typography>
      <Typography
        variant="p"
        size="xs"
        weight="medium"
        color="neutral-700"
        className="whitespace-nowrap">
        {value}
      </Typography>
    </div>
  );
};

const TransactionMobile = ({ transaction, timezone }) => {
  return (
    <div className="flex flex-col justify-center gap-1 rounded-md border border-solid border-neutral-200 bg-white px-3 py-2.5">
      <div className="flex items-center gap-1">
        <Typography variant="label" size="medium" weight="medium">
          {formatDate(transaction.created_at, timezone, 'MM/dd/yyyy h:mm a')}
        </Typography>
        <TransactionStatus status={transaction.status} />
      </div>
      <div className="flex flex-wrap items-center gap-1.5">
        <TransactionItem value={transaction.type} label="Type" />
        <TransactionItem value={mString(transaction.amount_paid_self)} label="Amount" />
        <TransactionItem value={mString(transaction.surcharge_amount)} label="Tech. fee" />
        <TransactionItem value={mString(transaction.amount_total)} label="Total" />
      </div>
    </div>
  );
};

const ReceiptTransactionsTableMobile = ({ transactions, timezone }) => {
  const { device } = useUIContext();
  const isMobile = device === 'tablet-sm' || device === 'mobile';

  if (!isMobile) return null;

  return (
    <div className="flex flex-col gap-2">
      {transactions.map((transaction) => (
        <TransactionMobile key={transaction.id} transaction={transaction} timezone={timezone} />
      ))}
    </div>
  );
};

export default ReceiptTransactionsTableMobile;
